import { Component, Input } from '@angular/core'

import { ExpandedHuntPackageRecord } from '@cyborg-monorepo/hunter/common'
import {
  TypographyComponent,
  SegmentedProgressBarComponent,
  ProgressSegment,
} from '@hyperkit'

import {
  buildQueryProgressSegments,
  countQueriesInPackage,
  totalQueries,
} from '../../../helpers/query-status-helper'

@Component({
  selector: 'hunt-package-list-item',
  imports: [TypographyComponent, SegmentedProgressBarComponent],
  templateUrl: './packages.component.html',
  styleUrl: './packages.component.scss',
})
export class HuntPackageListItem {
  @Input() huntPackage: ExpandedHuntPackageRecord

  /** Segments for the progress bar */
  get queryStatusSegments(): ProgressSegment[] {
    if (!this.huntPackage) return []

    const counts = countQueriesInPackage(this.huntPackage)
    return buildQueryProgressSegments(counts)
  }

  /** Total number of queries (toDo + run + skip) */
  get totalQueries(): number {
    if (!this.huntPackage) return 0

    const counts = countQueriesInPackage(this.huntPackage)
    return totalQueries(counts)
  }
}
